import { useMemo } from "react";
import useSWR from "swr";

import { fetcher } from "@aprosoja/api";
import { GetMediasData } from "@aprosoja/types";

const useMedia = () => {
  const { data: mediaData, isLoading } = useSWR<GetMediasData>(
    [`/medias`],
    async ([url]) => fetcher(url),
    { revalidateOnMount: true, revalidateOnFocus: false }
  );

  const media = mediaData?.data;

  const photos = useMemo(
    () =>
      media
        ?.filter((it) => it.type === "PHOTO")
        ?.flatMap((media) =>
          media.files!.map((file) => ({
            createdAt: media.createdAt ?? "",
            file,
            title: media.title,
          }))
        ),
    [media]
  );

  const videos = useMemo(
    () =>
      media
        ?.filter((it) => it.type === "VIDEO")
        ?.flatMap((media) =>
          media.ytbLinks!.map((ytbLink) => ({
            createdAt: media.createdAt ?? "",
            ytbLink,
            title: media.title,
          }))
        ),
    [media]
  );

  return { photos, videos, isLoading };
};

export default useMedia;
